import axios from 'axios';
import { Redirect } from 'react-router-dom';

export const authenticate =(data,callback)=>{
    if(typeof window !=='undefined')
    {
        localStorage.setItem('jwt',JSON.stringify(data));
        callback();
    }
}

export const signout =()=>{
    if(typeof window !=='undefined')
    {
        localStorage.removeItem('jwt');
    }
    return axios.get('/signout',{withCredentials: true})
    .then(()=><Redirect to="/"/>)
    .catch(err=>console.log(err));
}

export const isAuthenticated =()=>{
    
    if(typeof window =='undefined')
    {
        return false;
    }
    if(localStorage.getItem('jwt'))
    {
        return JSON.parse(localStorage.getItem('jwt'));
    }
    else
    {
        return false;
    }
}